import { merge, has } from 'lodash';
import { BaseClient as InfraBaseClient, sessionManager } from 'vue-infra';
import Config from '@config/config';
import BaseClient from '@core/common/BaseClient';
import { RESOURCES_CONFIGURATION_TIMEOUT as TIMEOUT } from '@config/Consts';

const EVENTS = BaseClient.EVENTS;

// Todo: Remove when botSso and botPlatform domains will be added to CSDS
const CONVERSATION_BUILDER_DOMAINS = {
  z0: { botSSODomain: 'botsso.dev.lprnd.net', botPlatform: 'platform-dev.dev.lprnd.net' },
  z1: { botSSODomain: 'va.bc-sso.liveperson.net', botPlatform: 'va.bc-platform.liveperson.net' },
  z2: { botSSODomain: 'lo.bc-sso.liveperson.net', botPlatform: 'lo.bc-platform.liveperson.net' },
  z3: { botSSODomain: 'sy.bc-sso.liveperson.net', botPlatform: 'sy.bc-platform.liveperson.net' },
  'z1-a': { botSSODomain: 'va-a.bc-sso.liveperson.net', botPlatform: 'va-a.bc-platform.liveperson.net' },
};

const BOT_SSO_DOMAIN = 'botSSODomain';
const BOT_PLATFORM_DOMAIN = 'botPlatformDomain';

const RESOURCES = {
  BOT_SSO: 'botSSO',
  BOT_PLATFORM_DOMAINS: 'domains',
  BOT_PLATFORM_INTENTS: 'intents',
};

const RESOURCES_CONFIGURATION = {
  [RESOURCES.BOT_SSO]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET],
    URL_KEY: () => 'conversationBuilder.botSSO',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.BOT_PLATFORM_DOMAINS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET],
    URL_KEY: () => 'conversationBuilder.domains',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.BOT_PLATFORM_INTENTS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET],
    URL_KEY: () => 'conversationBuilder.intents',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
};


// Todo: Remove when botSso and botPlatform domains will be added to CSDS
function setConversationBuilderDomains(resolver) {
  let accountZone = sessionManager.getAccountZone();
  if (accountZone === 'qa' || !has(CONVERSATION_BUILDER_DOMAINS, accountZone)) {
    accountZone = 'z0';
  }
  const botSsoDomain = CONVERSATION_BUILDER_DOMAINS[accountZone].botSSODomain;
  const botPlatformDomain = CONVERSATION_BUILDER_DOMAINS[accountZone].botPlatform;
  resolver.addConfigValue(BOT_SSO_DOMAIN, botSsoDomain);
  resolver.addConfigValue(BOT_PLATFORM_DOMAIN, botPlatformDomain);
}


function createInfraBaseClient(options, config) {
  setConversationBuilderDomains(BaseClient.urlResolver.getUrlResolver());

  const { baseURL } = BaseClient.urlResolver.resolveUrl(RESOURCES_CONFIGURATION[config.resource]);

  const infraBaseClientOptions = {
    allowedMethods: RESOURCES_CONFIGURATION[config.resource].ALLOWED_METHODS,
    config: {
      baseURL,
      timeout: RESOURCES_CONFIGURATION[config.resource].TIMEOUT,
      data: {},
    },
    source: {
      appName: Config.moduleName,
      contextName: config.contextName,
    },
    retryConfig: BaseClient.getClientRetryConfig,
  };
  merge(infraBaseClientOptions, options);
  return new InfraBaseClient(infraBaseClientOptions);
}

class ConversationBuilderClient extends BaseClient {
  /*
  @param options {resource, infraBaseClientConfig}
 */
  constructor({
    infraBaseClientOptions,
    ...options
  }) {
    const infraBaseClient = createInfraBaseClient(infraBaseClientOptions, options);
    super({
      name: 'CBClient',
      infraBaseClient,
      ...options,
    });
  }
}

ConversationBuilderClient.EVENTS = EVENTS;

export {
  RESOURCES,
  EVENTS,
  ConversationBuilderClient,
};
